import React, {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import {ReactComponent as MenuIcon} from "../../../../assets/systemIcons/ic_menu.svg";
import {ReactComponent as Polko} from "../../../../assets/logos/polko.svg";
import { trackClick, getElementName } from "../../../../utils/analytics/analytics";
import { ANALYTICS_MODULES, ANALYTICS_SECTIONS, ANALYTICS_ELEMENT_TYPES } from "../../../../constants/analyticsConstants";

import DrawerMenu from "./DrawerMenu/DrawerMenu";

function Header({sticky = true}) {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [isNotDesktop, setIsNotDesktop] = useState(window.innerWidth <= 1024);

    // Escucha cambios de tamaño
    useEffect(() => {
        const handleResize = () => {
            setIsNotDesktop(window.innerWidth <= 1024);
            if (window.innerWidth > 1024) {
                setIsOpen(false);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const options = [
        {option: "Inicio", link: "/"},
        {option: "Productos", link: "/productos"},
    ];

    const footer = (
        <>
            <p className="drawer__footer-question">¿Sos productor?</p>
            <a
                href="https://www.polko.com.ar"
                target="_blank"
                rel="noopener noreferrer"
                className="drawer__footer-link"
                onClick={() => {
                    trackClick({
                        module: ANALYTICS_MODULES.LANDING,
                        section: ANALYTICS_SECTIONS.LANDING_HEADER,
                        elementName: getElementName(ANALYTICS_ELEMENT_TYPES.LINK, ANALYTICS_SECTIONS.LANDING_HEADER, 'unite_equipo'),
                        elementType: ANALYTICS_ELEMENT_TYPES.LINK
                    });
                }}
            >
                Unite al equipo Polko
            </a>
        </>
    );

    return (
        <>
            <section
                className={`clientes__header__container ${sticky ? "is-sticky" : "is-static"}`}
            >
                <Polko
                    className="clientes__header__logo"
                    onClick={() => {
                        trackClick({
                            module: ANALYTICS_MODULES.LANDING,
                            section: ANALYTICS_SECTIONS.LANDING_HEADER,
                            elementName: getElementName(ANALYTICS_ELEMENT_TYPES.IMAGE, ANALYTICS_SECTIONS.LANDING_HEADER, 'logo'),
                            elementType: ANALYTICS_ELEMENT_TYPES.IMAGE
                        });
                        navigate("/");
                    }}
                />

                {isNotDesktop && (
                    <MenuIcon
                        className="clientes__header__burguer"
                        onClick={() => {
                            trackClick({
                                module: ANALYTICS_MODULES.LANDING,
                                section: ANALYTICS_SECTIONS.LANDING_HEADER,
                                elementName: getElementName(ANALYTICS_ELEMENT_TYPES.ICON, ANALYTICS_SECTIONS.LANDING_HEADER, 'menu'),
                                elementType: ANALYTICS_ELEMENT_TYPES.ICON
                            });
                            setIsOpen(true);
                        }}
                    />
                )}

                {/* Menú desktop */}
                {!isNotDesktop && (
                    <nav className="clientes__header__nav">
                        <button
                            type="button"
                            className="clientes__header__nav-link"
                            onClick={() => {
                                trackClick({
                                    module: ANALYTICS_MODULES.LANDING,
                                    section: ANALYTICS_SECTIONS.LANDING_HEADER,
                                    elementName: getElementName(ANALYTICS_ELEMENT_TYPES.LINK, ANALYTICS_SECTIONS.LANDING_HEADER, 'inicio'),
                                    elementType: ANALYTICS_ELEMENT_TYPES.LINK
                                });
                                navigate("/");
                            }}
                        >
                            Inicio
                        </button>
                        <button
                            type="button"
                            className="clientes__header__nav-link"
                            onClick={() => {
                                trackClick({
                                    module: ANALYTICS_MODULES.LANDING,
                                    section: ANALYTICS_SECTIONS.LANDING_HEADER,
                                    elementName: getElementName(ANALYTICS_ELEMENT_TYPES.LINK, ANALYTICS_SECTIONS.LANDING_HEADER, 'productos'),
                                    elementType: ANALYTICS_ELEMENT_TYPES.LINK
                                });
                                navigate("/productos");
                            }}
                        >
                            Productos
                        </button>
                        <a
                            href="https://www.polko.com.ar"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                                trackClick({
                                    module: ANALYTICS_MODULES.LANDING,
                                    section: ANALYTICS_SECTIONS.LANDING_HEADER,
                                    elementName: getElementName(ANALYTICS_ELEMENT_TYPES.LINK, ANALYTICS_SECTIONS.LANDING_HEADER, 'soy_productor'),
                                    elementType: ANALYTICS_ELEMENT_TYPES.LINK
                                });
                            }}
                        >
                            Soy productor
                        </a>
                    </nav>
                )}
            </section>

            {isNotDesktop && (
                <DrawerMenu
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    options={options}
                    footer={footer}
                />
            )}
        </>
    );
}

export default Header;
